module.exports = __webpack_public_path__ + "media/images/pdf_form/LaBelleAurore-e67e4a43ef5ad09a7b9c2df671705d11.ttf";